import {Link} from 'react-router-dom';

const NotFound = () => {
    return (
        <div>
            <p style={{textAlign:"center"}}>
                <p>Nema rezultata</p>
                <Link to="/">Idi na Početnu stranicu</Link>
            </p>
        </div>);
};

export default NotFound;